export default "__VITE_ASSET__BT80OhN2__"